import baseRequest from "../_core/baseRequest";

export default {
    getCompanyListFilter: () => baseRequest.get("/filterlistofcompany"),
    getCompanyUserList: () => baseRequest.get("/companyuserlist")
};
